import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@adnoc/servicebox';
import { IEmailMapping } from '../interfaces/i-email-mapping';

@Injectable()
export class UserMappingService {
  constructor(private apiService: ApiService) {}

  getCurrentMapping$(): Observable<IEmailMapping> {
    return this.apiService.get<IEmailMapping>(`user-mapping`);
  }

  deleteMapping$(): Observable<void> {
    return this.apiService.delete(`user-mapping`);
  }

  changeMapping$(targetEmployeeEmail: string): Observable<void> {
    return this.apiService.post<void>(
      `user-mapping/target/${targetEmployeeEmail}`
    );
  }
}
